import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import { useTranslation } from 'react-i18next';
import Input from 'Components/Atoms/Input/Input';
import InputTags from 'Components/Molecules/InputTags/InputTags';

export default function SubTagEditorDrawer(props) {
    const { onCancel, subTag, onSubmit, onError } = props;
    const [keywords, setKeywords] = useState(subTag.categorization_keywords || []);
    const [name, setName] = useState(subTag.name ?? '');
    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('categories');

    const handleSubmit = async (ev) => {
        ev.preventDefault();

        if (name.trim() === '') return;

        setProcessing(true);

        try {
            await onSubmit({
                name,
                categorization_keywords: keywords,
            });
        } catch (error) {
            onError(error, {
                title: subTag.id ? t('error-updating-subtag-title') : t('error-creating-subtag-title'),
                description: subTag.id
                    ? t('error-updating-subtag-description')
                    : t('error-creating-subtag-description'),
            });
        } finally {
            setProcessing(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="h-full flex flex-col">
            <div className="grid gap-6 pt-4 mb-6">
                <Input
                    data-autofocus="true"
                    label={t('name')}
                    name="name"
                    value={name}
                    onChange={(ev) => setName(ev.target.value)}
                />

                <InputTags label={t('categorization-keywords-label')} tags={keywords} onChange={setKeywords} />
            </div>
            <div className="grow" />

            <div className="sticky bottom-0 bg-white pt-2 pb-4 z-10">
                <div className="flex gap-2">
                    <Button
                        variant="primary"
                        isBusy={processing}
                        type="submit"
                        className="grow"
                        testId="subtag-editor.save"
                    >
                        {t('save')}
                    </Button>
                    <Button onClick={onCancel} className="grow" testId="subtag-editor.cancel">
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        </form>
    );
}

SubTagEditorDrawer.propTypes = {
    onCancel: PropTypes.func.isRequired,
    subTag: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    onError: PropTypes.func.isRequired,
};
